import { useParams } from "react-router";
import { useAtomValue } from "jotai";
import { shareLinkDataAtom, shareLinkStatusAtom } from "@/store/shareLink";
import ShareLinkExpiredView from "./ShareLinkExpiredView";
import SharedAnalyticsPage from "@/presentation/pages/analytics/SharedAnalytics.page";

const ShareLinkPage = () => {
  const { resourceSlug } = useParams<{ resourceSlug: string; token: string }>();
  const status = useAtomValue(shareLinkStatusAtom);
  const shareLink = useAtomValue(shareLinkDataAtom);

  if (status === "expired" || status === "error") {
    return <ShareLinkExpiredView />;
  }

  if (status !== "valid" || !shareLink) {
    return null;
  }

  if (resourceSlug !== shareLink.resourceSlug) {
    return <ShareLinkExpiredView />;
  }

  if (resourceSlug === "analytics") {
    return <SharedAnalyticsPage />;
  }

  return <ShareLinkExpiredView />;
};

export default ShareLinkPage;
